(function () {
  'use strict';

  function initShippingCheck(el) {
    var input   = el.querySelector('.shipping-transparency__input');
    var button  = el.querySelector('.shipping-transparency__button');
    var btnText = el.querySelector('.shipping-transparency__button-text');
    var spinner = el.querySelector('.shipping-transparency__spinner');
    var results = el.querySelector('.shipping-transparency__results');
    var dateEl  = el.querySelector('.shipping-transparency__delivery-date');
    var speedEl = el.querySelector('.shipping-transparency__delivery-speed');
    var errBox  = el.querySelector('.shipping-transparency__error');
    var errMsg  = el.querySelector('.shipping-transparency__error-message');

    if (!input || !button) return;

    /* ── Enable / disable button based on input length ── */
    function syncBtn() {
      button.disabled = input.value.replace(/\D/g, '').length !== 6;
    }

    input.addEventListener('input', function () {
      input.value = input.value.replace(/\D/g, '').slice(0, 6);
      syncBtn();
      hide(results);
      hide(errBox);
    });

    syncBtn();

    /* ── Click → estimate ── */
    button.addEventListener('click', function () {
      var pin = input.value.replace(/\D/g, '');
      if (pin.length !== 6) return;
      setLoading(true);
      hide(results);
      hide(errBox);

      /* Small delay to show loading state, then show estimate */
      setTimeout(function () {
        try {
          var estimate = getEstimate(pin);
          show(estimate);
        } catch (e) {
          showErr('Unable to check delivery. Please try again.');
        } finally {
          setLoading(false);
        }
      }, 600);
    });

    /* ── Helpers ── */
    function setLoading(on) {
      button.disabled = on;
      if (btnText) btnText.textContent = on ? 'Checking…' : 'Check';
      if (spinner) spinner.classList.toggle('hidden', !on);
    }

    function hide(el) { if (el) el.classList.add('hidden'); }

    function show(data) {
      if (dateEl)  dateEl.textContent  = 'Estimated delivery: ' + data.date;
      if (speedEl) { speedEl.textContent = data.speed; speedEl.classList.remove('hidden'); }
      if (results) results.classList.remove('hidden');
    }

    function showErr(msg) {
      if (errMsg) errMsg.textContent = msg;
      if (errBox) errBox.classList.remove('hidden');
    }

    /* ── Delivery estimate logic (pincode-based) ── */
    function getEstimate(pin) {
      var prefix2 = pin.slice(0, 2);
      var prefix3 = pin.slice(0, 3);

      /* Days by major city prefix */
      var daysMap = {
        '11': 2,  /* Delhi NCR */
        '40': 2,  /* Mumbai */
        '56': 3,  /* Bangalore */
        '60': 3,  /* Chennai */
        '70': 4,  /* Kolkata */
        '41': 3,  /* Pune */
        '50': 4,  /* Hyderabad */
        '38': 4,  /* Ahmedabad */
        '30': 4,  /* Jaipur */
        '22': 5   /* Lucknow */
      };

      var days = daysMap[prefix2] || daysMap[prefix3.slice(0,2)] || 5;

      var d = new Date();
      d.setDate(d.getDate() + days);
      var formatted = d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });

      var speed = days <= 1 ? 'Same Day Delivery'
                : days <= 2 ? 'Express Delivery'
                : days <= 4 ? 'Fast Delivery'
                : 'Standard Delivery';

      /* Save pincode for next visit */
      try { localStorage.setItem('shipping_pincode', pin); } catch (e) {}

      return { date: formatted, speed: speed };
    }

    /* ── Restore saved pincode ── */
    try {
      var saved = localStorage.getItem('shipping_pincode');
      if (saved && /^\d{6}$/.test(saved)) {
        input.value = saved;
        syncBtn();
      }
    } catch (e) {}
  }

  /* ── Init all instances on the page ── */
  function initAll() {
    document.querySelectorAll('.shipping-transparency').forEach(function (el) {
      if (!el._stInit) {
        el._stInit = true;
        initShippingCheck(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
}());
